import React, { useRef, useEffect } from 'react';
import Logo from '../../assets/les-logo.png'
import styles from './Welcome.module.css'

function Welcome() {
  const welcomeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    (window as any).welcomeRef = welcomeRef

  }, []);

  return (
    <div ref={welcomeRef} className={styles.container}>
      <div className={styles.texto}>
        <h1> LABORATÓRIO DE <br /> ENGENHARIA DE <br /> SOFTWARE </h1> <br />
        <h4> ENSINO, PESQUISA E EXTENSÃO </h4>
      </div>

      <img src={Logo} alt='Logo' className={styles.logo} />
    </div>
  )
}

export default Welcome;